/* eslint-disable @atlassian/tangerine/import/no-parent-imports */
import type { MessageDescriptor } from 'react-intl-next';

import type { PriceSegmentation, ProductId } from '../../../../services/modal-data/types';

import { messages } from './messages';

type HeadingText = {
	headingBreak?: MessageDescriptor;
	message: MessageDescriptor;
	noAddedCost?: boolean;
};

/**
 * Determines the appropriate heading message and values based on pricing and products
 */
export const getHeadingText = (
	priceSegmentation: PriceSegmentation,
	userProducts: ProductId[],
): HeadingText => {
	const hasJira = userProducts.includes('jira');
	const hasConfluence = userProducts.includes('confluence');
	if (priceSegmentation !== 'increase' && hasJira && hasConfluence) {
		return {
			message: messages.headingNoPriceIncrease,
			noAddedCost: true,
		};
	}

	const hasLoom = userProducts.includes('loom');
	if (hasJira && hasLoom && userProducts.length === 2) {
		return {
			message: messages.headingJiraAndLoom,
			headingBreak: messages.headingDocs,
		};
	}

	if (hasJira && userProducts.length === 1) {
		return {
			message: messages.headingJiraOnly,
			headingBreak: messages.headingAIPowered,
		};
	}

	return {
		message: messages.headingPriceIncrease,
		headingBreak: messages.headingVideo,
	};
};
